import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
const {registerModule} = window;

class Stack {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUi();
    this.setVars();
    this.bindEvents();

    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 600);

    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 800);

    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 1200);
  }

  bindUi() {
    this.pinnedElement = document.querySelector('.content-container');
    this.headerElement = document.querySelector('.site-header');
    this.stackItems = Array.from(this.element.querySelectorAll('.stack-item'));
    this.stackItemsExceptFirst = this.stackItems.slice(1);
    this.stackItemsExceptLast = this.stackItems.slice(0, -1);
    this.stackContainer = this.element.querySelector('.stack__container');
  }

  setVars() {
    this.stagger = 1;
  }

  bindEvents() {
    window.addEventListener('load', this.handleDomLoaded.bind(this));
    window.screen.orientation.addEventListener('change', () => {
      ScrollTrigger.refresh();
    });
  }

  handleDomLoaded() {
    if (window.location.hash && document.getElementById(window.location.hash.slice(1)) && !['reload', 'back_forward'].includes(window.performance?.getEntries()[0]?.type)) {
      this.unresolvedJump = true;
      this.jumpTarget = document.getElementById(window.location.hash.slice(1));
    }
    const tl = gsap.timeline({
      defaults: {
        ease: 'none',
      },
      scrollTrigger: {
        trigger: this.element,
        start: 'center center',
        end: `+=${this.stackItemsExceptFirst.length * 200}%`,
        pin: true,
        scrub: true,
        onRefresh: () => {
          if (!this.jumpTarget || !this.unresolvedJump || this.jumpTarget.getBoundingClientRect().top <= 0) {
            this.unresolvedJump = false;
          } else {
            this.jumpTarget.scrollIntoView({behavior: 'instant'});
          }
        },
      },
    });

    tl.from(this.stackItemsExceptFirst, {
      y: window.innerHeight,
      stagger: {
        each: this.stagger / 2,
      },
    });
    tl.add(this.shrinkOnStack(), 0);
  }

  getScaleDecrement() {
    const cardWidth = this.element.querySelector('.stack-item__container').offsetWidth;
    return 1 - ((cardWidth - 32) / cardWidth);
  }

  shrinkOnStack() {
    const queue = [...this.stackItems];
    const shifted = [];
    const tl = gsap.timeline({
      defaults: {
        ease: 'none',
      },
    });
    this.stackItemsExceptLast.forEach(() => {
      shifted.push(queue[0]);
      queue.shift();

      if (queue.length > 0) {
        tl.to(shifted, {
          scale: () => `-=${this.getScaleDecrement()}`,
          delay: 0,
          transformOrigin: 'top center',
        });
      }
    });
    return tl;
  }
}


registerModule('Stack', Stack);

